import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Shapes({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M6.56458 14.4346C6.56458 13.7939 7.08393 13.2746 7.72458 13.2746H9.20616C9.84681 13.2746 10.3662 13.7939 10.3662 14.4346V15.9161C10.3662 16.5568 9.84681 17.0761 9.20616 17.0761H7.72458C7.08393 17.0761 6.56458 16.5568 6.56458 15.9161V14.4346Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" d="M17.5692 15.1763C17.5692 16.3499 16.6178 17.3012 15.4443 17.3012C14.2707 17.3012 13.3194 16.3499 13.3194 15.1763C13.3194 14.0028 14.2707 13.0515 15.4443 13.0515C16.6178 13.0515 17.5692 14.0028 17.5692 15.1763Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M11.6047 6.84288L9.977 9.66305C9.87874 9.83325 9.87871 10.0429 9.97692 10.2131C10.0751 10.3834 10.2567 10.4883 10.4532 10.4884H13.7086C13.9051 10.4883 14.0866 10.3834 14.1848 10.2131C14.283 10.0429 14.283 9.83325 14.1848 9.66305L12.5581 6.84288C12.4598 6.67246 12.2781 6.56744 12.0814 6.56744C11.8847 6.56744 11.7029 6.67246 11.6047 6.84288Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" d="M2.99609 7.99627C2.99609 5.23485 5.23467 2.99628 7.99609 2.99628H16.0036C18.765 2.99628 21.0036 5.23485 21.0036 7.99628V16.0038C21.0036 18.7652 18.765 21.0038 16.0036 21.0038H7.99609C5.23467 21.0038 2.99609 18.7652 2.99609 16.0038V7.99627Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Shapes;